import router from '@/router/index.js'
import store from '@/store'
import { getToken } from '@/axios/cookies.js'

router.beforeEach((to, from, next) => {
  const token = getToken();
  const whiteList = [
    '/',
    '/indexpage',
    '/indexpage/index',
    '/indexpage/productlist', // 商品列表
    '/indexpage/seckill', // 秒杀中心
    '/indexpage/discount', // 折扣中心
    '/indexpage/combination', // 拼团中心
    '/indexpage/getcoupon', // 优惠卷中心
    '/indexpage/noticedetail', // 图文详情

    // 调试使用
    // '/productDetail', // 商品详情
    // '/cart/settlement',  // 结算页面
    // '/cart/shoppingCart',  // 购物车页面
    // '/userInfo',  // 用户中心
    // '/client',  // 委托方管理
    // '/contacts',  // 联系人管理
    // '/myOrder',  // 我的委托单
    // '/orderDetail',  // 委托单详情
    // '/paymentInfo',  // 付款开票
  ];
  // 保存当前路由至状态中
  store.commit('setTargetRoute', to);
  console.log('---permission to---');
  console.log(to);
  // 进行路由跳转判断
  if (token) {
    next();
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      store.commit('setLoginVisible', true);
      next(from.path);  // 留在当前页面进行登录操作
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/permission.js